import { sessionTracker } from '@utils/session/session-activity.util';
import { isProdEnvironment } from '@/settings/environment.utils.js';

export default function (store) {
    if (!window.Cypress) {
        store.subscribe((params) => {
            try {
                checkConditions(params);
            } catch (err) {
                errorMessage(err);
            }
        });

        store.subscribeAction(({ type }) => {
            if (type === 'auth/logout' && sessionTracker) {
                try {
                    sessionTracker.dispose();
                } catch (err) {
                    errorMessage(err);
                }
            }
        });
    }
}

function checkConditions ({ type, payload }) {
    switch (type) {
        case 'auth/setAuthenticated': {
            if (!payload?.authenticated && sessionTracker) {
                sessionTracker.dispose();
            }

            break;
        }
    }
}

function errorMessage (err) {
    if (!isProdEnvironment()) {
        // eslint-disable-next-line no-console
        console.warn('Issue setting up session activity with error', err);
    }
}
